export const APIURL = 'https://dashboard-api.teq.capital'
